import PictureFrame from './PictureFrame';

export default PictureFrame;
